import Lock from '@mui/icons-material/Lock';

export interface OnboardStep {
  title: string;
  detail?: string;
}

interface Props {
  agentName: string;
  steps?: OnboardStep[];
}

const DEFAULT_STEPS: OnboardStep[] = [
  { title: 'Install the companion app', detail: 'On your phone.' },
  { title: 'Connect it to your Vault', detail: 'A one-tap pairing flow.' },
  { title: 'Run it once', detail: "Then it'll start filling this card." },
];

export function FirstTimeOnboard({ agentName, steps = DEFAULT_STEPS }: Props) {
  return (
    <div className="vault-onboard">
      <div className="vault-onboard__head">
        <div className="vault-onboard__kicker">Finish setup</div>
        <div className="vault-onboard__title">
          Three steps and {agentName} starts filling this workspace.
        </div>
      </div>
      <ol className="vault-onboard__steps">
        {steps.map((s, i) => (
          <li key={s.title} className="vault-onboard__step">
            <span className="vault-onboard__num">{i + 1}</span>
            <span className="vault-onboard__step-text">
              <span className="vault-onboard__step-title">{s.title}</span>
              {s.detail && <span className="vault-onboard__step-detail">{s.detail}</span>}
            </span>
          </li>
        ))}
      </ol>
      <div className="vault-onboard__footer">
        <Lock sx={{ fontSize: 13, color: 'currentColor' }} />
        <span>Nothing flows until you finish setup.</span>
      </div>
    </div>
  );
}
